import { apiGet, apiPut } from "./client";
export interface InstructionStop {
  stopNumber: number;
  isPickup?: boolean;
  location: {
    name?: string;
    addressLine?: string;
    postCode?: string;
    city?: string;
  };
  instructions: string;
  editable: boolean;
}
export interface OrderInstructions {
  fingerprint: string;
  stops: InstructionStop[];
}
export async function getOrderInstructions(
  token: string,
  workspace: string,
  order: string,
): Promise<OrderInstructions> {
  return (await apiGet(token, `/api/orders/${order}/instructions`, workspace))
    .data;
}
export async function saveOrderInstructions(
  token: string,
  workspace: string,
  order: string,
  fingerprint: string,
  changes: { stopNumber: number; instructions: string }[],
) {
  return apiPut(
    token,
    `/api/orders/${order}/instructions`,
    { fingerprint, changes },
    workspace,
  );
}
